import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const Piechart = prop => {
  const COLORS = [
    "#8884d8",
    "#9CAFAA",
    "#ACE2E1",
    "#67C6E3",
    "#9BB0C1",
    "#B3E5FC",
    "#FFB3B3",
    "#4ECDC4",
    "#FF6B6B",
    "#FFD93D"
  ];

  return (
    <React.Fragment>
      <ResponsiveContainer width="100%" height={240}>
        <PieChart width={400} height={400}>
          <Pie
            data={prop.dataPie}
            dataKey="value"
            cx="50%"
            cy="50%"
            innerRadius={30}
            outerRadius={80}
            labelLine={false} // ✅ เพิ่มเส้นช่วยให้ label แยกกันชัดเจน
            label={({
              cx,
              cy,
              midAngle,
              innerRadius,
              outerRadius,
              value,
              index
            }) => {
              // ถ้าค่าต่ำกว่า 3% ไม่แสดง label เพื่อลดความซ้อน
              if (value < 1) return null;

              // ปรับระยะห่าง label ให้แตกต่างกันเล็กน้อย
              const RADIAN = Math.PI / 180;
              const radius =
                innerRadius + (outerRadius - innerRadius) * 1.2 + index * 4; // ✅ ขยับออกเล็กน้อยตามลำดับ index

              const x = cx + radius * Math.cos(-midAngle * RADIAN);
              const y = cy + radius * Math.sin(-midAngle * RADIAN);

              return (
                <g>
                  <text
                    x={x}
                    y={y}
                    fill="#333"
                    textAnchor={x > cx ? "start" : "end"}
                    dominantBaseline="central"
                    style={{ fontSize: "12px", fontWeight: "500" }}
                  >
                    {prop.dataPie[index].name} {value}%
                  </text>

                  {/* แสดง value2 ด้านล่างถ้ามี */}
                  {prop.dataPie[index].value2 &&
                    <text
                      x={x}
                      y={y + 12}
                      fill="#666"
                      textAnchor={x > cx ? "start" : "end"}
                      dominantBaseline="central"
                      style={{ fontSize: "11px" }}
                    >
                      ({prop.dataPie[index].value2})
                    </text>}
                </g>
              );
            }}
          >
            {prop.dataPie.map((entry, index) =>
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            )}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
};

export default Piechart;
